import { NormalizeApi } from "../normalizeApi";
const BASE_ENDPOINT = 'base.rpc.products-base';
export const ProductsBaseApi = NormalizeApi({
  view: `${BASE_ENDPOINT}.view`,
  list: `${BASE_ENDPOINT}.index`,
  update: `${BASE_ENDPOINT}.update`,
  updateAll: `${BASE_ENDPOINT}.update-all`,
  printEpc: `${BASE_ENDPOINT}.print-epc-tag`,
  differenceZoneTags: `${BASE_ENDPOINT}.zone-tags-differences`,
  delete: `${BASE_ENDPOINT}.delete`,
  setDefective: `${BASE_ENDPOINT}.to-defective`,
  transfer: `${BASE_ENDPOINT}.transfer`
});